export const list = state => state.strategy.list;